export default __webpack_public_path__ + "static/media/cert.6e576e35.svg";